import { render } from "./BadgesPage.vue?vue&type=template&id=84927390&ts=true"
import script from "./BadgesPage.ts?vue&type=script&lang=ts"
export * from "./BadgesPage.ts?vue&type=script&lang=ts"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__